export const displayUserLanguage = (languages, langCode) => {
  if (!langCode || langCode === '') return 'N/A';
  const userLanguage = languages.find((language) => language.id === langCode);
  return userLanguage ? userLanguage.name : 'N/A';
};
